<template>
  <div class="addsite">
    <b-btn @click="show=true" id="addsite" class="add-site">
      <plus-icon class="icon"></plus-icon>
    </b-btn>
    <b-tooltip target="addsite" placement="left" triggers="hover">
      Add site
    </b-tooltip>
    <b-modal id="addsite" :lazy="true" centered title="Add your WordPress Site" v-model="show" @ok="addSite" :hide-header-close="true" class="addsitepopup" @show="instializeData" :no-fade="true">
      <div class="prompt-text alert alert-info" role="alert">
        Install and Activate the
        <strong>InfiniteWP Client</strong> plugin on your WordPress site before adding it here.
      </div>
      <form-alert :message="error.errorMsg" v-for="(error,index) in errors" :key="index"></form-alert>

      <div class="form-group mx-5">

        <b-form-group label="WP dashboard crendentials" label-for="url_input">
          <input id="url_input" ref="urlinput" class="form-control" type="text" @paste="handlePaste('url')" v-model="args.url" placeholder="WP-Admin URL" required />
        </b-form-group>
        <b-form-group label-for="username_input">
          <input id="username_input" class="form-control" type="text" @paste="handlePaste('username')" v-model="args.username" placeholder="Admin Username" required/>
        </b-form-group>
        <b-form-group label-for="username_input">
          <input id="username_input" class="form-control" type="text" @paste="handlePaste('activationKey')" v-model="args.activationKey" placeholder="Activation Key" required/>
        </b-form-group>
        <b-form-group label-for="group_input" label="Assign to groups" description="Unassigned sites will be assigned to the 'Unassigned' group.">
          <v-select id="time_zone" :options="options" multiple v-model="selectedGroups">
            <span slot="no-options">Sorry, no groups found.</span>
          </v-select>
        </b-form-group>

        <b-form-checkbox id="checkbox1" class="assign-new-gp-cont" v-model="addNewGroup">
          Assign to a new group
        </b-form-checkbox>
        <b-form-group label="New group name" v-if="addNewGroup" label-for="new_group_name">
          <input id="new_group_name" class="form-control" type="text" v-model="newGroupName" placeholder="Enter a name for the new group" required />
        </b-form-group>

      </div>
      <div slot="modal-footer" class="w-100">
        <div class="text-right">
          <b-btn variant="flat" @click="show=false">
            Cancel
          </b-btn>
          <b-btn variant="primary" class="px-3" @click="addSite()" :disabled="$v.args.$invalid">
            Add Site
            <spinner size="small" v-if="buttonLoaders.addSite"></spinner>
          </b-btn>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import PlusIcon from "../../assets/plus.svg";
import FormAlert from "../Common/FormAlert";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
export default {
  name: "addsite",
  components: {
    PlusIcon,
    FormAlert
  },

  data() {
    return {
      show: false,
      url: "",
      addNewGroup: false,
      newGroupName: "",
      selectedGroups: [],
      errors: [],
      buttonLoaders: {
        addSite: false
      },
      args: {
        username: "",
        siteName: "",

        url: "",
        activationKey: ""
      }
    };
  },
  mixins: [validationMixin],
  validations: {
    args: {
      url: {
        required
      },
      username: {
        required
      },
      activationKey: {
        required
      }
    }
  },
  computed: {
    options() {
      return _.map(_.values(this.$store.getters.getGroups), group => {
        return { label: group.name, value: group.groupID };
      });
    }
  },
  watch: {
    addNewGroup(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.$refs.groupname.focus();
        }, 100);
      }
    }
  },
  methods: {
    instializeData() {
      //Object.assign(this.$data, this.$options.data());

      Object.assign(this.$data, this.$options.data.apply(this));
      setTimeout(() => {
        this.$refs.urlinput.focus();
      }, 500);
    },
    addSite() {
      this.buttonLoaders.addSite = true;
      let payload = {};
      payload.action = "addSite";
      payload.args = {};
      payload.args.params = {};
      payload.args.params["URL_b64encoded"] = btoa(this.args.url);
      payload.args.params["activationKey"] = this.args.activationKey;
      payload.args.params["username"] = this.args.username;
      payload.args.params["siteName"] = this.args.siteName;
      payload.requiredData = {};
      payload.requiredData["getSites"] = 1;
      payload.requiredData["getGroupsSitesV3"] = 1;
      payload.requiredData["getPluginsAndThemesV3"] = 1;
      payload.requiredData["getSitesUpdatesV3"] = 1;

      if (this.selectedGroups) {
        payload.args.params["groupIDs"] = _.map(this.selectedGroups, "value");
      }
      if (this.addNewGroup && this.newGroupName) {
        payload.args.params["groupsPlainText"] = this.newGroupName;
      }

      this.$store
        .dispatch("sendAction", payload)
        .then(response => {
          this.buttonLoaders.addSite = false;
          this.$store.commit("SET_SITES", response.data.getSites);
          this.$store.commit("SET_GROUPS", response.data.getGroupsSitesV3);
          this.$store.commit(
            "UPDATE_SITES_UPDATES",
            response.data.getSitesUpdatesV3
          );
          this.$store.commit(
            "UPDATE_PLUGINS_AND_THEMES",
            response.data.getPluginsAndThemesV3
          );
          if (response.actionResult && response.actionResult.detailedStatus) {
            let errors = _.filter(
              response.actionResult.detailedStatus,
              status => {
                return status.status != "success";
              }
            );
            if (errors && errors.length > 0) {
              this.errors = errors;
              return;
            }
          }
          this.errors = [];
          this.show = false;
          
        })
        .catch(err => {
          this.buttonLoaders.addSite = false;
          
        });
    },
    handlePaste(key) {
      setTimeout(() => {
        let spilitedStrings = this.args[key].split("|^|");
        if (spilitedStrings.length > 1) {
          this.args.url = spilitedStrings[0];
          this.args.username = spilitedStrings[1];
          this.args.activationKey = spilitedStrings[2];
        }
      }, 10);
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/addsite.vue